import React, { useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "../common.css";
import Loading from "../components/Loading";

function Confirmation({ title, picture, firstButtonText }) {
  const navigate = useNavigate();
  const { created } = useParams();
  const [loading, setLoading] = useState(true);

  const pageImage = (
    <Image
      src={picture}
      className="main-picture"
      onLoad={() => {
        if (loading) {
          setLoading(false);
        }
      }}
    />
  );

  if (loading) {
    return <Loading pageImage={pageImage} />;
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="centered-container">{pageImage}</div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="title">{title}</div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="centered-container">
            <Button
              className="button-tertiary"
              onClick={() => navigate(`/${created}`)}
            >
              {firstButtonText}
            </Button>
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 6, offset: 3 }}
        >
          <div className="centered-container">
            <Button className="button-primary" onClick={() => navigate("/")}>
              Go Back to All Lists
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Confirmation;
